import React from "react";
import { Field, FormSpy } from "react-final-form";
import { Label } from "../../../shared/components/form/Layout";
import DateInput from "../../../shared/components/form/DateInput";
import InputNumber from "../../../shared/components/form/InputNumber";
import StopSelect from "../../../booking/components/form/StopSelect";
import FieldContainer from "../../../shared/containers/form/FieldContainer";
import ErrorContainer from "../../../shared/containers/form/ErrorContainer";
import { useTranslation } from "react-i18next";
import { selectArrival, selectDeparture } from "../../../../data/booking/actions/map";
import Divider from "../../../shared/components/Divider";
import SlideInAnimation from "../../../shared/components/SlideInAnimation";
import { MapPinIcon, CalendarIcon } from "@heroicons/react/20/solid";
import WithStage from "../../../shared/components/form/WithStage";
import { useDispatch, useSelector } from "react-redux";
import {startAt} from "../../../../data/booking/selectors/bike_transport_form";

const StepFormFields = ({ routeId, form }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isEditing = useSelector((state) => state.booking.booking.editingService);
    const startAtDate = useSelector(state => startAt(state.booking))

    return (<WithStage form={form} isEditing={isEditing}>
        {({updateStage, getFieldStage, stage })=> (<>
            <FormSpy
                subscription={{ values: true }}
                onChange={(values) => updateStage(values.values)}
            />
            <div className={`mt-8 mb-16 `}>
            <Divider className={"mb-8"}>{t("booking.bike_and_date")}</Divider>
            <div className="px-4 sm:flex sm:gap-16 sm:px-16">
                <div className="sm:w-1/2">
                    <FieldContainer name="bikes">
                        <Label htmlFor="bikes" className="col-xs-7">
                            {t("booking.bike_transport_bikes")} :{" "}
                        </Label>
                        <div>
                            <Field
                                className="form-control"
                                id="bikes"
                                name="bikes"
                                placeholder="0"
                                component={InputNumber}
                            />
                        </div>
                        <ErrorContainer name="bikes" />
                    </FieldContainer>
                </div>
                <div className="mt-4 sm:mt-0 sm:w-1/2">
                    <FieldContainer name="date">
                        <Label Icon={CalendarIcon} htmlFor="date">
                            {t("booking.departure_date")}
                        </Label>
                        <div>
                            <Field
                                id="date"
                                name="date"
                                placeholder="jj/mm/aaaa"
                                component={DateInput}
                                disabledAfter={startAtDate}
                            />
                            <ErrorContainer name="date" />
                        </div>
                    </FieldContainer>
                </div>
            </div>
            <Divider>{t("booking.departure")}</Divider>
            <div className="space-y-8 px-4 lg:px-16">
                <FieldContainer name="from" >
                    <Label htmlFor="from" Icon={MapPinIcon}>
                        {t("booking.departure_from")}
                    </Label>
                    <Field
                        id="from"
                        name="from"
                        routeId={routeId}
                        purpose="lodging"
                        component={StopSelect}
                        onChange={(value) => {
                            dispatch(selectDeparture(value?.firstInput?.step));
                        }}
                    />
                    <ErrorContainer name="from" />
                </FieldContainer>
            </div>
            <SlideInAnimation show={stage >= getFieldStage("from")}>
                <Divider>Arrivée</Divider>
                <div className="space-y-8 px-4 lg:px-16">
                    <FieldContainer name="to">
                        <Label htmlFor="to" Icon={MapPinIcon}>
                            {t("booking.departure_to")}
                        </Label>
                        <Field
                            id="to"
                            name="to"
                            routeId={routeId}
                            purpose="lodging"
                            onChange={(value) => {
                                dispatch(selectArrival(value?.firstInput?.step));
                            }}
                            component={StopSelect}
                        />
                        <ErrorContainer name="to" />
                    </FieldContainer>
                </div>
            </SlideInAnimation>
        </div>
        </>)}
        </WithStage>
    );
};

export default StepFormFields;
